import { createRoot } from "@wordpress/element";
import App from "./components/App";

document
	.querySelectorAll(".wp-block-weather-search-bar-marine")
	.forEach((el) => {
		const root = el.querySelector(".search-bar-marine__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
